import React from "react";
import "./WeekDayRow.scss";

const WEEK_DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const WeekDayRow = ({ cellWidth }) => {
  return (
    <div className="week-day-row">
      {WEEK_DAYS.map((day) => (
        <div key={day} className="day-cell" style={{ width: cellWidth }}>
          <span className="day-text">{day}</span>
        </div>
      ))}
    </div>
  );
};

export default WeekDayRow;
